'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchLayout = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _deep = require('helpers/deep');

var _Search = require('../Search.constants');

var _SearchVenue = require('./SearchVenue');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SearchLayout = exports.SearchLayout = function SearchLayout() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  (0, _classCallCheck3.default)(this, SearchLayout);

  var modeledData = (0, _extends3.default)({}, data);
  var venuePaths = [];
  if (config.layoutName === _Search.RESULTS_LAYOUT) {
    venuePaths = ['web_search_results_01.data.map_items', 'web_search_results_01.data.venue_tab_items'];
  } else if (config.layoutName === _Search.HEADER_LAYOUT) {
    venuePaths = ['nearby_venues.data'];
  }

  // Model venue paths
  venuePaths.forEach(function (path) {
    var value = (0, _deep.deepExtract)(path, modeledData, []).map(function (venue) {
      return new _SearchVenue.SearchVenue(venue, { distanceUnit: config.distanceUnit });
    });
    if (value.length) {
      (0, _deep.deepAssign)(path, modeledData, value);
    }
  });

  (0, _assign2.default)(this, modeledData);
};